import { getFoundation } from '../foundation';

import type { ThemeOptions } from '@mui/material';
import type { Foundation } from '@kep/kcds-foundation';
import type { ThemeMode } from '../foundation';

type Elevation = Foundation['elevation'];

declare module '@mui/material/styles' {
  interface Theme {
    elevation: Elevation;
  }
  interface ThemeOptions {
    elevation: Elevation;
  }
}

export const createElevation = (themeMode: ThemeMode): ThemeOptions['elevation'] => {
  const foundation = getFoundation(themeMode);

  return foundation.elevation;
};
